import React, {Component} from "react";

import LoaderButton from "../components/LoaderButton";
import { Auth, API } from "aws-amplify";

export default class Confirmation extends Component {
  constructor(props){
    super(props);

    this.state = {
        isLoading: false,
        confirmationCode: "",
        errorMsg: ""
    };
  }



  validateConfirmationForm(){
    return this.state.confirmationCode.length > 0;
  }

  handleChange = event => {

    this.setState({
      [event.target.id]: event.target.value
    });

  }


  handleConfirmationSubmit = async event => {
    event.preventDefault();
    this.setState( { isLoading: true } );

    try{
      await Auth.confirmSignUp(this.props.email, this.state.confirmationCode);

      var userDetails = await Auth.signIn (this.props.email, this.props.password);
      this.addUserProfileToServer({
        emailId: this.props.email,
        fullName: this.props.fullname,
        shareDetails: this.props.shareDetails
      });
      this.props.userHasAuthenticated(true);
      this.props.history.push("/");
    }catch(e){
      alert(e.message);
      this.setState({ isLoading: false });
    }
  }

  addUserProfileToServer(userInfo){
    API.post("retnetindia", "/user/profile", {
      body: userInfo
    })
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div class="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

  render(){
    return(
      <div className="loginContainer">
            <div className="login-header retnet-yrsa-font">
                <h4>CONFIRMATION CODE</h4>
            </div>
          {this.getErrorElement()}
          <form className="form-default" role="form" onSubmit={this.handleConfirmationSubmit} >
              <div className="row">
                  <div className="col-12">
                      <div className="form-group">

                          <input type="text" id="fullname"
                              className="form-control form-control-lg"
                              value={this.props.fullname}
                              disabled
                              className="form-control form-control-lg rounded" />

                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-12">
                      <div className="form-group">

                          <input type="email" id="email"
                             value={this.props.email}
                             disabled
                             className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">

                          <input type="text"
                                id="confirmationCode"
                                value={this.state.confirmationCode}
                                onChange={this.handleChange}
                                placeholder="Please Enter Your Activation Code"
                                className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>


              <div className="mt-1 ">
                  <small className="">Please check your email for confirmation code.</small>
              </div>


              <LoaderButton block bsSize="large"
                           type="submit"
                           isLoading={this.state.isLoading}
                           text="Activate"
                           loadingText="Activating..."
                           className="btn btn-lg btn-block btn-success rounded retnet-16-font-size retnet-bold-font"/>

          </form>

      </div>
    );
  }

  renderold(){

    return(
      <section className="slice sct-color-2 loginpagebg">
          <div className="container">
              <div className="row justify-content-center">
                  <div className="col-lg-6">
                      <div className="card form-card form-card--style-2">
                          <div className="form-header text-center">
                              <div className="form-header-icon">
                                    <img src="/images/logo_retnetindia.png" />
                              </div>
                          </div>
                          <div className="form-body">
                              <div className="text-center px-2">
                                  <h4 className="heading heading-4 strong-400 mb-0">Please Confirm Your Account</h4>
                              </div>
                              {this.getErrorElement()}

                              <form onSubmit={this.handleConfirmationSubmit}
                                     className="form-default mt-4"
                                     data-toggle="validator" role="form">

                                     <div className="row">
                                         <div className="col-md-6">
                                             <div className="form-group">
                                                 <label className="control-label">Email Id</label>
                                                 <input type="email" id="email"
                                                      className="form-control form-control-lg"
                                                      value={this.props.email}
                                                      disabled />
                                             </div>
                                         </div>

                                     </div>

                                     <div className="row">
                                         <div className="col-md-6">
                                             <div className="form-group">
                                                 <label className="control-label">Full Name</label>
                                                 <input type="text" id="name"
                                                      className="form-control form-control-lg"
                                                      value={this.props.fullname}
                                                      disabled />
                                             </div>
                                         </div>

                                     </div>

                                  <div className="row">
                                      <div className="col-md-6">
                                          <div className="form-group">
                                              <label className="control-label">Confirmation Code</label>
                                              <input type="text" id="confirmationCode"
                                                   className="form-control form-control-lg"
                                                   value={this.state.confirmationCode}
                                                   onChange={this.handleChange} />
                                          </div>
                                      </div>

                                  </div>


                                  <div className="mt-1 ">
                                      <small className="">Please check your email for confirmation code.</small>
                                  </div>

                                  <LoaderButton block bsSize="large"
                                              disabled={!this.validateConfirmationForm()}
                                              type="submit"
                                              isLoading={this.state.isLoading}
                                              text="Verify"
                                              loadingText="Verifying..."
                                              className="btn btn-styled btn-lg btn-info mt-4"/>

                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>

    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Confirmation.js